module.exports = __webpack_public_path__ + "img/cp-4.45935219.png";